function getFileFromEntry(entry: FileSystemFileEntry): Promise<File> {
  return new Promise((resolve, reject) => entry.file(resolve, reject));
}

async function readAllDirectoryEntries(dir: FileSystemDirectoryEntry): Promise<FileSystemEntry[]> {
  const reader = dir.createReader(),
    entries: FileSystemEntry[] = [];
  let batch: FileSystemEntry[];
  do {
    batch = await new Promise<FileSystemEntry[]>((resolve, reject) =>
      reader.readEntries(resolve, reject)
    );
    entries.push(...batch);
  } while (batch.length > 0);
  return entries;
}

async function readEntry(entry: FileSystemEntry): Promise<File[]> {
  if (entry.isFile) return [await getFileFromEntry(entry as FileSystemFileEntry)];
  if (entry.isDirectory) {
    const children = await readAllDirectoryEntries(entry as FileSystemDirectoryEntry);
    const nested = await Promise.all(children.map(readEntry));
    return nested.flat();
  }
  return [];
}

/**
 * Extracts all files from a DataTransfer, recursively traversing any dropped folders.
 * Falls back to dataTransfer.files if the FileSystem Entry API is unavailable.
 */
export async function getFilesFromDataTransfer(dataTransfer: DataTransfer): Promise<File[]> {
  if (dataTransfer.items?.length > 0) {
    const entries = Array.from(dataTransfer.items)
      .map(item => item.webkitGetAsEntry?.())
      .filter(Boolean);
    if (entries.length > 0) {
      const results = await Promise.all(entries.map(readEntry));
      return results.flat();
    }
  }
  return Array.from(dataTransfer.files);
}
